/** Whether chat/search can use this project's vector index. */
export function isProjectChatAvailable(project) {
  if (!project) return false;
  if (project.chat_available != null) return Boolean(project.chat_available);
  const meta = project.meta || {};
  return meta.embedding_status === 'completed' && meta.vector_status === 'completed';
}

export function getProjectChatUnavailableMessage(project) {
  if (project?.chat_unavailable_message) return project.chat_unavailable_message;
  return (
    'Chat is unavailable until at least one file has been processed into the search index. '
    + 'Open the RAG Pipeline tab and run processing.'
  );
}
